module.exports = __webpack_public_path__ + "static/media/t52@2x.f7d8f491.png";